import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { resetRedux, removeTheToken, checkImpersonateUser  } from "../../util/util";
import { useTranslation } from "react-i18next";
import { changeLanguageHandler } from "../../util/userLanguageUtils";
import { connect } from "react-redux";
import { revealRedirectionLink, revealLoginRedirectionLink } from "../../util/helpURLNavigation";
import { removeChat } from "../../util/chatBotUtils";
import CPFallbackPage from "./CPFallbackPage";
//START - REDBALL CONFIG
import { REDBALL_FEATURE_TOGGLE } from "../../constants/appConstants";
//END - REDBALL CONFIG
import PropTypes from "prop-types";

function RevealSessionExpiredPage(props) {
  const [t, i18n] = useTranslation("loginTranslation");

  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
  }, []);

  useEffect(() => {
    if (Cookies.get("userLanguage")) {
      i18n.changeLanguage(changeLanguageHandler(Cookies.get("userLanguage")));
    }
    resetRedux();
    removeTheToken();
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  const forceLoginBackToVCCP = () => {
    if (REDBALL_FEATURE_TOGGLE) {
      checkImpersonateUser() ? window.open(revealRedirectionLink(), "_self") : window.open(revealLoginRedirectionLink(), "_self");
    } else {
      window.open(revealRedirectionLink(), "_self");
    }
  };

  return (
    <CPFallbackPage
      windowSize={props.windowSize.width}
      ariaLabel="Session expired"
      pageTitle={t("Session expired")}
      pageContent={t("For your security, your session has expired due to inactivity. Please log in again to continue.")}
      buttonId="reveal-session-exp-login-button"
      buttonHandler={() => forceLoginBackToVCCP()}
      buttonName={t("LOG IN")}
      buttonAriaLabel="Log In"
    />
  );
}

const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
    emailAddress: state.ACCOUNT.emailAddress,
    regionId: state.ACCOUNT.regionId,
  };
};

RevealSessionExpiredPage.propTypes = {
  regionId: PropTypes.string,
  emailAddress: PropTypes.string,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  title: PropTypes.string,
};

export default connect(mapStateToProps)(RevealSessionExpiredPage);
